import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../../headerone/Main';
import Breadcrumb from '../../Breadcrumb/Main';
import Academicleft from '../../IITTP/Academic/Academicleft';

function Main() {
    return (
        <>
            <Header />

            <Breadcrumb title="Home" subtitle="Academic" />

            <section className="project-detail">
                <div className="container">

                    <div className="row">

                        {/* Left Menu */}
                        <div className="col-lg-3 col-md-4">
                            <Academicleft activeIndex={16}/>
                        </div>

                        {/* Right Content */}
                        <div className="col-lg-9 col-md-8">

                            <div className="c-heading">
                                <h1>Honours Programme</h1>
                            </div>

                            <div className="border">

                                <div className="mt-3 ms-3 me-3">

                                    <h4 className="mb-3">
                                        Guidelines for the Honours Programme:
                                    </h4>

                                    <div style={{ lineHeight: '1.7' }}>

                                        <p>
                                            <strong>1.</strong>&nbsp;&nbsp;
                                            A student must earn at least 12 additional credits,
                                            over and above the prescribed degree requirements,
                                            from the department elective courses offered by
                                            his/her own department, to be eligible for the award
                                            of a B.Tech. Degree with Honours.
                                        </p>

                                        <p>
                                            <strong>2.</strong>&nbsp;&nbsp;
                                            BTP II is mandatory to earn B.Tech. with honours.
                                        </p>

                                        <p>
                                            <strong>3.</strong>&nbsp;&nbsp;
                                            No contact course/ MOOC course shall be allowed to
                                            count as an Honours course.
                                        </p>

                                        <p>
                                            <strong>4.</strong>&nbsp;&nbsp;
                                            Extra courses completed for Honours will be counted
                                            in the CGPA calculation.
                                        </p>

                                        <p>
                                            <strong>5.</strong>&nbsp;&nbsp;
                                            To receive the degree with Honours, a student must
                                            have a minimum CGPA of 8.5 at the time of graduation.
                                        </p>

                                        <p>
                                            <strong>6.</strong>&nbsp;&nbsp;
                                            The degree shall be awarded as B.Tech. with Honours.
                                        </p>

                                        <p>
                                            <strong>7.</strong>&nbsp;&nbsp;
                                            In the case of a dual degree, B.Tech. with Honours
                                            will be awarded along with M.Tech. in the department,
                                            provided the student meets the minimum CGPA requirement
                                            of 8.5 and complete additional credits for honours over
                                            and above the prescribed degree requirements.
                                        </p>

                                        <p>
                                            <strong>8.</strong>&nbsp;&nbsp;
                                            The degree certificate shall explicitly state:
                                        </p>

                                        <p style={{ marginLeft: '35px' }}>
                                            <em>
                                                “B.Tech. with Honours in [Programme Name].
                                                E.g. B.Tech. with Honours in Engineering Physics.”
                                            </em>
                                        </p>

                                        <p>
                                            <strong>9.</strong>&nbsp;&nbsp;
                                            The maximum duration of the B.Tech. programme with
                                            Honours shall remain the same as that of the regular
                                            B.Tech. programme.
                                        </p>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>
            </section>
        </>
    );
}

export default Main;